import React, { Component } from 'react';
import { Modal, Button, Input } from 'semantic-ui-react';
import FilterGroupSection, { emptyFilterGroup, normalizeFilterGroup } from '../../../Commons/FilterGroupSection';

var moment = require('moment');

export default class DateRangeModal extends Component {
    constructor(props) {
        super(props);
        this.storageKey = "DateRangeModalFilterState_" + (props.title || "default");
        var defaultState = {
            filterGroup: emptyFilterGroup(),
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            isStartDateError: false,
            isEndDateError: false
        };

        const savedState = sessionStorage.getItem(this.storageKey);
        if (savedState) {
            try {
                const parsed = JSON.parse(savedState);
                this.state = { ...defaultState, ...parsed, filterGroup: normalizeFilterGroup(parsed.filterGroup), isStartDateError: false, isEndDateError: false };
            } catch (e) {
                this.state = defaultState;
            }
        } else {
            this.state = defaultState;
        }
    }

    componentWillUnmount() {
        const stateToSave = {
            filterGroup: this.state.filterGroup,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        };
        sessionStorage.setItem(this.storageKey, JSON.stringify(stateToSave));
    }

    getParameters = () => {
        return {
            ...this.state.filterGroup,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        };
    }

    onSave = () => {
        if (this.state.startDate === null || this.state.startDate === '') {
            this.setState({ isStartDateError: true });
            return;
        }

        if (this.state.endDate === null || this.state.endDate === '') {
            this.setState({ isEndDateError: true });
            return;
        }

        this.props.onSave();
    }

    startDateOnChange = (e) => {
        this.setState({
            isStartDateError: false,
            startDate: e.target.value
        });
    }

    endDateOnChange = (e) => {
        this.setState({
            isEndDateError: false,
            endDate: e.target.value
        });
    }

    render() {
        return (
            <Modal size='tiny' open={this.props.open}>
                <Modal.Header> Date Range </Modal.Header>
                <Modal.Content>
                    <div className='w3-row'>
                        <div className='w3-col s4 m4 l4' style={{ padding: '10px 0' }}>
                            <label>Start Date</label>
                        </div>
                        <div className='w3-col s7 m7 l7'>
                            <Input type='date' value={this.state.startDate} error={this.state.isStartDateError} onChange={this.startDateOnChange.bind(this)} />
                        </div>
                    </div>
                    <div className='w3-row' style={{ marginTop: '5px' }}>
                        <div className='w3-col s4 m4 l4' style={{ padding: '10px 0' }}>
                            <label>End Date</label>
                        </div>
                        <div className='w3-col s7 m7 l7'>
                            <Input type='date' value={this.state.endDate} error={this.state.isEndDateError} onChange={this.endDateOnChange.bind(this)} />
                        </div>
                    </div>
                    <div style={{ clear: 'both', marginTop: '10px' }}>
                        <FilterGroupSection value={this.state.filterGroup} onChange={filterGroup => this.setState({ filterGroup })} />
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button basic content="Generate" onClick={this.onSave}></Button>
                    <Button basic content="Cancel" onClick={this.props.onCancel}></Button>
                </Modal.Actions>
            </Modal>
        )
    }
}